export default function validate(values) {
  const errors = {};

  for (const [key, value] of Object.entries(values)) {
    if (!value) {
      errors[key] = `${key} is Required`;
    } else if (value.length === 0 || value > 50) {
      errors[key] = `${key} allow maximum 30 characters`;
    }
  }

  return errors;
}
